// Organization entity audit log event backend names array
export const ORG_ENTITY_AUDIT_LOG_EVENT_NAMES = [
    'organization-care-team-member-add',
    'organization-care-team-member-delete',
    'organization-care-team-member-update',
    // 'organization-collaborator-add',     // This is an org client record audit event
    // 'organization-collaborator-remove',  // This is an org client record audit event
    // 'organization-invoice-creation',     // This is an org client record audit event
    'organization-note-creation',
    'organization-note-delete',
    'organization-note-update',
    'organization-owner-role-assignment',
    'organization-paid-status-update',
    'organization-publicly-visible-status-update',
    'organization-session-timeout-update',
    'organization-user-creation',
    'organization-user-creation-on-invite-accept',
    'organization-user-delete',
    'organization-user-group-add',
    'organization-user-group-add-bulk',
    'organization-user-group-remove',
    'organization-user-group-remove-bulk',
    'organization-user-role-assignment',
    'organization-user-update',
] as const;

// Type for organization entity audit log event names
export type OrgEntityAuditLogEventName = (typeof ORG_ENTITY_AUDIT_LOG_EVENT_NAMES)[number];

// Mapping object from org entity audit log event names to display names
const ORG_ENTITY_AUDIT_LOG_EVENT_TO_DISPLAY_MAP: Record<OrgEntityAuditLogEventName, string> = {
    'organization-care-team-member-add': 'Organization Care Team Member Added',
    'organization-care-team-member-delete': 'Organization Care Team Member Deleted',
    'organization-care-team-member-update': 'Organization Care Team Member Updated',
    // 'organization-collaborator-add': 'Organization Collaborator Added',               // This is an org client record audit event
    // 'organization-collaborator-remove': 'Organization Collaborator Removed',          // This is an org client record audit event
    // 'organization-invoice-creation': 'Organization Invoice Created',                  // This is an org client record audit event
    'organization-note-creation': 'Organization Note Created',
    'organization-note-delete': 'Organization Note Deleted',
    'organization-note-update': 'Organization Note Updated',
    'organization-owner-role-assignment': 'Organization Owner Role Assigned',
    'organization-paid-status-update': 'Organization Paid Status Updated',
    'organization-publicly-visible-status-update': 'Organization Publicly Visible Status Updated',
    'organization-session-timeout-update': 'Organization Session Timeout Updated',
    'organization-user-creation': 'Organization User Created',
    'organization-user-creation-on-invite-accept': 'Organization User Creation On Invite Accepted',
    'organization-user-delete': 'Organization User Deleted',
    'organization-user-group-add': 'Organization User Group Added',
    'organization-user-group-add-bulk': 'Organization User Group Add Bulked',
    'organization-user-group-remove': 'Organization User Group Removed',
    'organization-user-group-remove-bulk': 'Organization User Group Remove Bulked',
    'organization-user-role-assignment': 'Organization User Role Assignment',
    'organization-user-update': 'Organization User Updated',
};

/**
 * Maps an organization entity audit log event name to its corresponding display name
 * @param eventName - The org entity audit log event name
 * @returns The display name for the event, or undefined if not found
 */
export function getOrgEntityAuditLogEventDisplayName(eventName: string): string | undefined {
    return ORG_ENTITY_AUDIT_LOG_EVENT_TO_DISPLAY_MAP[eventName as OrgEntityAuditLogEventName];
}

/**
 * Maps an organization entity audit log event name to its corresponding display name with fallback
 * @param eventName - The org entity audit log event name
 * @param fallback - Fallback value if mapping not found (defaults to the event name)
 * @returns The display name for the event, or the fallback value
 */
export function getOrgEntityAuditLogEventDisplayNameWithFallback(eventName: string, fallback?: string): string {
    return ORG_ENTITY_AUDIT_LOG_EVENT_TO_DISPLAY_MAP[eventName as OrgEntityAuditLogEventName] ?? fallback ?? eventName;
}
